export const NEXT_NUM = 'NEXT_NUM'
export const START = 'START'
export const CLEAR = 'CLEAR'
